"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("antd/lib/row/style/css");
var row_1 = __importDefault(require("antd/lib/row"));
require("antd/lib/switch/style/css");
var switch_1 = __importDefault(require("antd/lib/switch"));
require("antd/lib/col/style/css");
var col_1 = __importDefault(require("antd/lib/col"));
require("antd/lib/form/style/css");
var form_1 = __importDefault(require("antd/lib/form"));
require("antd/lib/input/style/css");
var input_1 = __importDefault(require("antd/lib/input"));
var _excluded = ["initialValues"];
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var ObjectForm_1 = __importStar(require("../ObjectForm"));
var jsx_runtime_1 = require("@welldone-software/why-did-you-render/jsx-runtime");
var styles = {
    columnPublished: {
        width: 200
    }
};
var transformInitialValues = function transformInitialValues(v) {
    return _objectSpread(_objectSpread({}, v), {}, {
        published: !!v.published_dt
    });
};
var ReleaseForm = /*#__PURE__*/ react_1.default.memo(function (_ref) {
    var _transformedInitialVa, _releases$0$version, _releases$;
    var initialValues = _ref.initialValues, props = _objectWithoutProperties(_ref, _excluded);
    var releases = (0, react_redux_1.useSelector)(function (state) {
        return state.releases.items;
    });
    var objectForm = (0, ObjectForm_1.useObjectForm)(_objectSpread({
        initialValues: initialValues,
        transformInitialValues: transformInitialValues
    }, props));
    var transformedInitialValues = objectForm.transformedInitialValues;
    return (0, jsx_runtime_1.jsxs)(ObjectForm_1.default, _objectSpread(_objectSpread({
        objectForm: objectForm
    }, props), {}, {
        children: [(0, jsx_runtime_1.jsxs)(row_1.default, {
                gutter: 12,
                children: [(0, jsx_runtime_1.jsx)(col_1.default, {
                        flex: 1,
                        children: (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                            label: "Version",
                            children: (0, jsx_runtime_1.jsx)(input_1.default, {
                                disabled: true,
                                value: (_transformedInitialVa = transformedInitialValues.version) !== null && _transformedInitialVa !== void 0 ? _transformedInitialVa : ((_releases$0$version = (_releases$ = releases[0]) === null || _releases$ === void 0 ? void 0 : _releases$.version) !== null && _releases$0$version !== void 0 ? _releases$0$version : 0) + 1
                            })
                        })
                    }), (0, jsx_runtime_1.jsx)(col_1.default, {
                        style: styles.columnPublished,
                        children: (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                            label: "Published",
                            children: (0, jsx_runtime_1.jsx)(switch_1.default, {
                                checked: transformedInitialValues.published
                            })
                        })
                    })]
            }), (0, jsx_runtime_1.jsx)(form_1.default.Item, {
                name: "release_notes",
                label: "Release Notes",
                rules: ObjectForm_1.RULES_REQUIRED_BASIC,
                children: (0, jsx_runtime_1.jsx)(input_1.default.TextArea, {
                    rows: 5,
                    disabled: transformedInitialValues.published
                })
            })]
    }));
});
exports.default = ReleaseForm;
